<template>
    <div>
        <div class="crumbs">
            <Breadcrumb v-bind:menuList="menuList"></Breadcrumb>
        </div>
        <div class="container">
            <el-form :inline="true" class="demo-form-inline">
                <el-form-item label="主播:">
                    <el-input class="s-input" v-model="queryParams.username" placeholder="请输入主播名称" clearable></el-input>
                </el-form-item>
                <el-form-item label="直播间名称:">
                    <el-input class="s-input" v-model="queryParams.name" placeholder="请输入直播间名称" clearable></el-input>
                </el-form-item>
                <el-form-item label="状态:">
                    <el-select v-model="queryParams.state" placeholder="全部" clearable @change="changeQuery">
                        <el-option label="上线" :value="2"></el-option>
                        <el-option label="下线" :value="1"></el-option>
                    </el-select>
                </el-form-item>
                <div style="float: right">
                    <el-button type="primary" @click="changeQuery()">搜索</el-button>
                </div>
                <div class="action">
                    <el-button type="primary" @click="sync" v-if="isSync">同步</el-button>
                    <el-button type="primary" v-else><i class="el-icon-loading"></i>同步中</el-button>
                </div>
            </el-form>
            <el-table v-loading="loading" element-loading-text="数据加载中" :cell-style="cellstyle" stripe border :data="pageInfo.list" class="el-table">
                <el-table-column prop="id" label="id" width="80" align="center"></el-table-column>
                <el-table-column label="直播间ID" prop="room_id" align="center" width="80"></el-table-column>
                <el-table-column label="封面图" align="center" width="80" prop="image">
                    <template slot-scope="scope">
                        <el-image @click="showBigImg(scope.$index)" style="height:23px;width:30px;" fit="cover" :class="`column${scope.$index}`" :src="scope.row.image" :preview-src-list="[scope.row.image]">
                            <div slot="error" class="image-slot">
                                <el-image :src="defaultImg" class="center_image"></el-image>
                            </div>
                        </el-image>
                    </template>
                </el-table-column>

                <el-table-column label="直播间名称" prop="name" align="center" width="200"></el-table-column>
                <el-table-column label="主播" prop="username" align="center" width="120"></el-table-column>
                <el-table-column label="直播链接" prop="room_url" align="center"></el-table-column>
                <el-table-column label="直播状态" prop="live_status " align="center" width="100">
                    <template slot-scope="scope">
                        <el-tag type="info" v-if="scope.row.live_state  ===  101">直播中</el-tag>
                        <el-tag type="primary" v-if="scope.row.live_state  === 102">未开始</el-tag>
                        <el-tag type="primary" v-if="scope.row.live_state  === 103">已结束</el-tag>
                        <el-tag type="primary" v-if="scope.row.live_state  === 104">禁播</el-tag>
                        <el-tag type="primary" v-if="scope.row.live_state  === 105">暂停中</el-tag>
                        <el-tag type="primary" v-if="scope.row.live_state  === 106">异常</el-tag>
                        <el-tag type="primary" v-if="scope.row.live_state  === 107">已过期</el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="开播时间" prop="stime" width="160" align="center"></el-table-column>
                <el-table-column label="结束时间" prop="etime" width="160" align="center"></el-table-column>
                <el-table-column label="状态" prop="state" align="center" width="100">
                    <template slot-scope="scope">
                        <el-tag type="info" v-if="scope.row.state === 1">下线</el-tag>
                        <el-tag type="primary" v-if="scope.row.state === 2">上线</el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="操作" align="center" width="120" fixed="right">
                    <template slot-scope="scope">
                        <el-button type="text" icon="el-icon-edit" @click="edit(scope.$index, scope.row)">编辑</el-button>
                        <el-button v-if="scope.row.state === 2" type="text" class="red" @click="state(scope.row, 1)">下线
                        </el-button>
                        <el-button v-if="scope.row.state === 1" type="text" class="green" @click="state(scope.row, 2)">
                            上线</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <Pagination v-bind:pageInfo="pageInfo" v-on:refreshPageSize="refreshPageSize" v-on:refreshPageNum="refreshPageNum" />
        </div>
        <el-dialog title="编辑" :visible.sync="addVisible" width="600px" class="dialog_box">
            <el-form class="form-box" ref="form" v-bind:rules="rules" v-bind:model="form" v-loading.body="loading" label-position="left" label-suffix=":" label-width="100px" size="large" element-loading-text="上传中">
                <el-form-item label="直播间名称" prop="name">
                    <el-input type="text" auto-complete="off" v-model="form.name" placeholder="请输入直播间名称"></el-input>
                </el-form-item>
                <el-form-item label="主播" prop="username">
                    <el-input type="text" auto-complete="off" v-model="form.username" placeholder="请输入主播名称"></el-input>
                </el-form-item>
                <el-form-item label="直播链接" prop="room_url">
                    <el-input type="text" auto-complete="off" v-model="form.room_url" placeholder="请输入直播链接"></el-input>
                </el-form-item>
                <!-- 图片上传 -->
                <el-form-item label="封面图" prop="image">
                    <el-input v-model="form.image" placeholder="请输入图片链接"></el-input>
                    <el-button @click.prevent="choiceImg">选择图片</el-button>
                    <el-upload class="avatar-uploader up" :action="IMAGE_UPLOAD_PRO_URL" :show-file-list="false" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload" name="file" :headers="header">
                        <img v-if="form.image" :src="form.image" class="avatar" />
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>
                    <span class="span_gray">建议尺寸140*140像素</span>
                </el-form-item>
                <el-form-item label="起止时间" prop="time">
                    <el-date-picker ref="drawDate" :picker-options="pickerOptions" style="margin-left: 5px;" v-model="form.time" value-format="yyyy-MM-dd HH:mm:ss" type="datetimerange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="addVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveData">提 交</el-button>
            </div>
        </el-dialog>
        <!-- 上线、下线提示框 -->
        <el-dialog title="提示" :visible.sync="confirmVisible" width="300px" center>
            <div class="del-dialog-cnt">{{ confirmContent }}</div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="confirmVisible = false">取 消</el-button>
                <el-button type="primary" @click="stateData">确 定</el-button>
            </span>
        </el-dialog>
        <!-- 选择图片对话框 -->
        <div class="img">
            <Picture :ImgVisible="ImgVisible" @toggleImg="toggleImg" @getImg="getImg"></Picture>
        </div>
    </div>
</template>

<script>
import Breadcrumb from '@/components/Breadcrumb';
import Pagination from '@/components/Pagination';
import { request } from '@/common/request';
import { deal } from '@/common/main';
let loads = new loadEvents();
import Picture from '@/components/Picture';
import loadEvents from '@/utils/loading'
import {IMAGE_UPLOAD_PRO_URL} from "../../common/const";
export default {
    name: 'StoreInfo',
    components: {
        Breadcrumb,
        Pagination,
        Picture
    },
    data() {
        return {
            IMAGE_UPLOAD_PRO_URL:IMAGE_UPLOAD_PRO_URL,
            ImgVisible: false,
            isSync: true,
            defaultImg: require('../../assets/img/timg.jpg'),
            pickerOptions: {
                // disabledDate(time) {
                //     return time.getTime() < Date.now() - 8.64e7;
                // }
            },
            menuList: ['直播', '直播管理'],
            loading: false,
            header: {},
            queryParams: {
                page: 1,
                pagesize: 10,
            },
            confirmVisible: false,
            confirmContent: '',
            pageInfo: {},
            addVisible: false,
            rules: {
                name: [{
                    required: true,
                    message: '直播间名称不能为空',
                    trigger: 'blur'
                }],
                username: [{
                    required: true,
                    message: '主播不能为空',
                    trigger: 'blur'
                }],
                image: [
                    { validator: deal.checkImage, trigger: ['blur', 'change'], required: true, }
                ],
                room_url: [
                    { validator: deal.checkUrl, trigger: ['blur', 'change'], required: true, }
                ],
                time: [{
                    required: true,
                    message: '起止时间不能为空',
                    trigger: 'blur'
                }],
                // state: [{
                //     required: true,
                //     message: '状态不能为空',
                //     trigger: 'blur'
                // }],

            },
            platformList: [],
            positionList: [],
            form: {
                name: '',
                state: null,
                time: null
            },

        };
    },
    created() {
        this.loadData();
    },
    methods: {
        toggleImg(val) { // 关闭 img对话框
            this.ImgVisible = val;
        },
        choiceImg() {
            this.ImgVisible = true
        },
        getImg(url) {// 获取选择的img
            this.$set(this.form, 'image', url);
        },
        //直播列表
        loadData() {
            this.loading = true;
            let _this = this
            request.get('/goods/live/room/list', this.queryParams).then(ret => {
                if (ret.code == 1) {
                    this.loading = false;
                    this.pageInfo = ret.data;
                    this.pageInfo.list = ret.data.list;
                    this.pageInfo.list.map(function (val) {
                        val.stime = deal.timestamp(val.stime, 'unix');
                        val.etime = deal.timestamp(val.etime, 'unix');
                        return val;
                    })
                } else {
                    this.$message.error(ret.msg);
                }
            });
        },
        edit(index, row) {
            const item = this.pageInfo.list[index];
            let time = [item.stime, item.etime]
            //处理时间
            this.form = Object.assign({}, item);
            this.$set(this.form, 'time', time);
            this.addVisible = true;
        },
        //状态
        state(row, state) {
            if (state == 2) {
                this.confirmContent = '确定是否上线?';
            } else {
                this.confirmContent = '确定是否下线?';
            }
            this.form = Object.assign({}, row);
            this.form.state = state;
            this.form.ctime = deal.timestamp(this.form.ctime);
            this.form.etime = deal.timestamp(this.form.etime);
            this.confirmVisible = true;
        },
        // 确定下线
        stateData() {
            request.post('/goods/live/room/edit', this.form).then(ret => {
                if (ret.code == 1) {
                    this.$message.success('操作成功');
                    this.loadData();
                    this.confirmVisible = false;
                } else {
                    this.$message.error(ret.msg);
                }
            });
        },
        // 查看大图
        showBigImg(index) {
            this.$nextTick(function () {
                let shows = document.getElementsByClassName(`column${index}`)
                let show = shows[0].getElementsByClassName('el-image-viewer__wrapper')
                show[0].style['display'] = 'block'
                let dom = show[0].getElementsByClassName('el-image-viewer__mask')
                dom[0].addEventListener('click', function () {
                    show[0].style['display'] = 'none'
                })
            })
        },
        //图片上传
        handleAvatarSuccess(res, file) {
            if (res.code == 1) {
                loads.close()
                this.$set(this.form, 'image', res.data.uri);
            }
        },
        beforeAvatarUpload(file) {
            loads.open('.avatar-uploader .el-upload', '上传中')
            const _this = this
            return deal.imageFormat(file, _this, 300)
        },
        //新增编辑
        saveData() {
            if (this.$refs.form) {
                this.$refs.form.validate(valid => {
                    if (valid) {
                        var url = '/goods/live/room/edit';
                        //处理时间
                        this.form.stime = deal.timestamp(this.form.time[0]);
                        this.form.etime = deal.timestamp(this.form.time[1]);
                        request.post(url, this.form).then(ret => {
                            if (ret.code == 1) {
                                this.addVisible = false;
                                this.$message.success('编辑成功');
                                this.$refs.form.clearValidate()
                                this.loadData();
                            } else {
                                this.$message.error(ret.msg);
                            }
                        });
                    } else {
                        this.$message.error('请补全信息');
                        return false;
                    }
                });
            };
        },
        changeQuery() {
            this.queryParams.page = 1;
            this.loadData();
        },
        refreshPageSize(val) {
            this.queryParams.pagesize = val;
            this.loadData();
        },
        refreshPageNum(val) {
            this.queryParams.page = val;
            this.loadData();
        },
        // 同步
        sync() {
            this.isSync = false
            request.post('/goods/live/room/syn').then(ret => {
                if (ret.code == 1) {
                    this.isSync = true
                    this.$message.success('同步成功');
                    this.loadData();
                } else {
                    this.$message.error(ret.msg);
                }
            });
        },
        cellstyle() {
            return 'text-align: center';
        },
    }
};
</script>
<style scoped>
.red {
    color: #ff0000;
}

.green {
    color: green;
}

/* 对话框样式 */

.dialog_box >>> .el-dialog__body {
    padding: 20px 30px 20px 60px;
}

.dialog_box >>> .el-dialog__header {
    padding: 30px 30px 10px;
}

.dialog_box .el-form-item--small.el-form-item {
    margin-bottom: 20px;
}

/* 图片样式 */
.dialog_box .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 140px;
    height: 140px;
    line-height: 140px;
    text-align: center;
}

.dialog_box .avatar {
    font-size: 28px;
    width: 140px;
    height: 140px;
    line-height: 140px;
}

.dialog_box .span_gray {
    font-size: 12px;
    color: gray;
}

.dialog_box .up {
    margin-top: 10px;
    margin-bottom: -10px;
}
.dialog_box .el-button {
    margin-left: 20px;
}
</style>
